import { render } from "./patient-token.vue?vue&type=template&id=897bfec4&scoped=true"
import script from "./patient-token.vue?vue&type=script&lang=js"
export * from "./patient-token.vue?vue&type=script&lang=js"

import "./patient-token.vue?vue&type=style&index=0&id=897bfec4&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-897bfec4"]])

export default __exports__